import script from "./SetupChecklistCompact.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupChecklistCompact.vue?vue&type=script&setup=true&lang=js"

import "./SetupChecklistCompact.vue?vue&type=style&index=0&id=31457586&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31457586"]])

export default __exports__